import { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { withStyles } from "@mui/styles";
import moment from "moment";
import ValidateIcon from "@mui/icons-material/Check";
import CircularProgress from "@mui/material/CircularProgress";
import { timeToFloat } from "../../time";
import { throwErrorMessage } from "../../lib/error_helper";
import { getCurrentOrLastImputation } from "../../redux/imputations/imputationsActions";
import Timepicker from "../Input/Timepicker";
import Divider from "@mui/material/Divider";
import CustomizedTextField from "../Input/CustomizedTextField";
import { getCurrentFunctionName } from "../../performanceModeManager";
import { getGpsPosition } from "../../redux/gps/gpsActions";

const styles = {
    appBar: {
        position: "relative",
        marginBottom: "10px",
    },
    flex: {
        flex: 1,
    },
};

class StartInterventionModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpenned: props.opened,
            startTime: moment().seconds(0).milliseconds(0),
            startDate: moment().seconds(0).milliseconds(0),
            startTimeModified: false,
        };

        this.props.getCurrentOrLastImputation();
    }

    componentDidMount() {
        if (navigator.geolocation) this.props.getGpsPosition.bind(this.props.authorizedApps);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let modifiedState = prevState;

        if (!modifiedState.modalOpenned && modifiedState.modalOpenned !== nextProps.opened) {
            modifiedState.startDate = moment().seconds(0).milliseconds(0);
            modifiedState.startTime = moment().seconds(0).milliseconds(0);
            modifiedState.startTimeModified = false;
        }

        modifiedState.modalOpenned = nextProps.opened;
        return modifiedState;
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props.opened !== nextProps.opened ||
            this.props.gpsInProgress !== nextProps.gpsInProgress ||
            this.props.currentOrLastImputation !== nextProps.currentOrLastImputation ||
            this.state.startTime !== nextState.startTime
        );
    }

    close() {
        this.setState({ modalOpenned: false });
        this.props.closeModal();
    }

    onStartDateChange(newValue) {
        this.setState({
            startTime: moment(newValue).seconds(0).milliseconds(0),
            startTimeModified: true,
        });
    }

    start() {
        let startTimeAsDate = this.state.startTime.toDate();
        let startTime = timeToFloat(startTimeAsDate.getHours(), startTimeAsDate.getMinutes());
        let now = new Date();
        let nowTime = timeToFloat(now.getHours(), now.getMinutes());

        if (nowTime < startTime) {
            this.props.throwErrorMessage({
                title: "Erreur",
                message: "La date d'arrivée doit-être antérieure ou égale à l'heure actuelle",
            });

            return;
        }

        this.props.startIntervention(this.state.startDate, this.state.startTime, this.state.startTimeModified);
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        const { classes } = this.props;

        return (
            <Dialog
                fullScreen
                aria-labelledby="simple-dialog-title"
                open={this.state.modalOpenned}
                onClose={this.close.bind(this)}
            >
                <Toolbar />
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.close.bind(this)} aria-label="Close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" color="inherit" className={classes.flex}>
                            {"Démarrer l'intervention"}
                        </Typography>
                        {this.props.gpsInProgress ? (
                            <CircularProgress color="inherit" />
                        ) : (
                            <IconButton color="inherit" onClick={this.start.bind(this)} aria-label="Validate">
                                <ValidateIcon />
                            </IconButton>
                        )}
                    </Toolbar>
                </AppBar>
                <DialogContent className="without-side-padding">
                    {this.props.currentOrLastImputation ? (
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                <Typography variant="subtitle1" color="inherit" className="full_size">
                                    {"Imputation " +
                                        (this.props.currentOrLastImputation.in_progress ? "courante" : "précédente")}
                                </Typography>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                                <CustomizedTextField
                                    id="dateStart"
                                    disabled
                                    label={"Date de début"}
                                    className="full_size"
                                    value={moment(this.props.currentOrLastImputation.date_start).format(
                                        "DD/MM/YYYY HH:mm"
                                    )}
                                />
                            </div>
                            {!this.props.currentOrLastImputation.in_progress ? (
                                <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                                    <CustomizedTextField
                                        id="dateEnd"
                                        disabled
                                        label={"Date de fin"}
                                        className="full_size"
                                        value={moment(this.props.currentOrLastImputation.date_end).format(
                                            "DD/MM/YYYY HH:mm"
                                        )}
                                    />
                                </div>
                            ) : null}
                            <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                                <CustomizedTextField
                                    id="activity"
                                    disabled
                                    label={"Type d'activité"}
                                    className="full_size"
                                    value={
                                        this.props.currentOrLastImputation.activity
                                            ? this.props.currentOrLastImputation.activity.name
                                            : ""
                                    }
                                />
                            </div>
                            {this.props.currentOrLastImputation.business ? (
                                <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                                    <CustomizedTextField
                                        id="affairOt"
                                        disabled
                                        label={"Affaire/OT"}
                                        className="full_size"
                                        value={this.props.currentOrLastImputation.business}
                                    />
                                </div>
                            ) : null}
                            <Divider variant="fullWidth" className="full_size control-margin-top" />
                        </div>
                    ) : null}
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                            <Timepicker
                                id="start-date"
                                mode="24h"
                                label="Heure de début de l'intervention"
                                className="full_size"
                                value={new Date(this.state.startTime)}
                                onChange={this.onStartDateChange.bind(this)}
                                fullWidth={true}
                            />
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        currentOrLastImputation: state.imputations.currentOrLastImputation,
        authorizedApps: state.authorizedApps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        throwErrorMessage: (errObj) => dispatch(throwErrorMessage(errObj)),
        getCurrentOrLastImputation: () => dispatch(getCurrentOrLastImputation()),
        getGpsPosition: (authorizedApps) => dispatch(getGpsPosition(authorizedApps)),
    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(StartInterventionModal);
